/* global google */

const GetDistance = async (clientLocation, musicologieLocations) => {
    let result;

    try {
        const rawResult = await searchLocation(
            clientLocation,
            musicologieLocations
        );
        result = rawResult.rows[0].elements.map((res, idx) => {
            return {
                id: musicologieLocations[idx].id,
                distance: res.distance.text,
                duration: res.duration.text,
            };
        });
    } catch (err) {
        console.log("An error occurred", err);
        result = null;
    }
    return result;
};

// Auxiliary functions
// wrap google api's callback to an async function
const searchLocation = async (clientLocation, musicologieLocations) => {
    //console.log(clientLocation, musicologieLocations);
    let promise = await new Promise((resolve, reject) => {
        var measureDistance = (distances, status) => {
            if (status !== google.maps.DistanceMatrixStatus.OK) {
                reject(status);
            }
            resolve(distances);
        };

        var service = new google.maps.DistanceMatrixService();
        const clientCoords = clientLocation.coords;

        service.getDistanceMatrix(
            {
                origins: [
                    new google.maps.LatLng(
                        clientCoords.latitude,
                        clientCoords.longitude
                    ),
                ],
                destinations: musicologieLocations.map((e) => e.address),
                travelMode: "DRIVING",
                unitSystem: google.maps.UnitSystem.IMPERIAL,
                avoidTolls: true,
            },
            measureDistance
        );
    }).catch(function (err) {
        throw err;
    });

    return promise;
};

export { GetDistance };
